import React from 'react';
import ServiceAreaDetail from '../ServiceAreaDetail';

// Dedicated page component for /service-areas/manhattan-ny
const ManhattanPage = () => <ServiceAreaDetail slug="manhattan-ny" />;

export default ManhattanPage;
